import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
import { CreateSubmissionResponse, ExaminationSubmissionResult, BanInformation } from '../../../core';
export var EXAMINATION_SUBMISSION_API = 'EXAMINATION_SUBMISSION_API';
export var ExaminationSubmissionApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(ExaminationSubmissionApi, _AxiosApi);

  var _super = _createSuper(ExaminationSubmissionApi);

  function ExaminationSubmissionApi(axiosInstance) {
    var _this;

    _classCallCheck(this, ExaminationSubmissionApi);

    _this = _super.call(this, 'examination-submissions', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(ExaminationSubmissionApi, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.axios.post(this.url, input);

              case 3:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                return _context.abrupt("return", CreateSubmissionResponse.create(parsedResponseBody.data));

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 8]]);
      }));

      function create(_x) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "submit",
    value: function () {
      var _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(useCaseInput) {
        var id, url, jsonResponse, parsedResponseBody, response, resultOrError, banInformation;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                id = useCaseInput.id;
                url = "".concat(this.url, "/").concat(id, "/submit");
                _context2.next = 5;
                return this.axios.put(url);

              case 5:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                response = parsedResponseBody.data;
                resultOrError = ExaminationSubmissionResult.fromJson(response.result);

                if (!resultOrError.isFailure) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", Result.fail(resultOrError.error));

              case 11:
                banInformation = response.banInformation === undefined ? undefined : response.banInformation ? BanInformation.create(response.banInformation).getValue() : null;
                return _context2.abrupt("return", Result.ok(_objectSpread(_objectSpread({
                  id: response.id,
                  attendeeId: response.attendeeId,
                  submitTime: response.submitTime,
                  result: resultOrError.getValue()
                }, banInformation !== undefined ? {
                  banInformation: banInformation
                } : {}), response.rejectionInfo !== undefined ? {
                  rejectionInfo: response.rejectionInfo
                } : {})));

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 15]]);
      }));

      function submit(_x2) {
        return _submit.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(useCaseInput) {
        var id, _input, url;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                id = useCaseInput.id, _input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(id);
                _context3.next = 5;
                return this.axios.patch(url, _objectSpread(_objectSpread({}, _input), {}, {
                  audioPlayStats: _input !== null && _input !== void 0 && _input.audioPlayStats ? {
                    audioFileId: _input.audioPlayStats.audioFileId,
                    scope: _input.audioPlayStats.scope
                  } : undefined
                }));

              case 5:
                return _context3.abrupt("return", Result.ok());

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function update(_x3) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref) {
        var submissionId, response, body;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                submissionId = _ref.submissionId;
                _context4.prev = 1;
                _context4.next = 4;
                return this.axios.patch("".concat(this.url, "/").concat(submissionId, "/close"));

              case 4:
                response = _context4.sent;
                body = response.data;
                return _context4.abrupt("return", Result.ok(body.data));

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](1);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[1, 9]]);
      }));

      function close(_x4) {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }, {
    key: "ban",
    value: function () {
      var _ban = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref2) {
        var submissionId, message;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                submissionId = _ref2.submissionId, message = _ref2.message;
                _context5.prev = 1;
                _context5.next = 4;
                return this.axios.patch("".concat(this.url, "/").concat(submissionId, "/ban"), {
                  message: message
                });

              case 4:
                return _context5.abrupt("return", Result.ok());

              case 7:
                _context5.prev = 7;
                _context5.t0 = _context5["catch"](1);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 10:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[1, 7]]);
      }));

      function ban(_x5) {
        return _ban.apply(this, arguments);
      }

      return ban;
    }()
  }]);

  return ExaminationSubmissionApi;
}(AxiosApi);